import InputDate from "@/Components/Base/Input/InputDate";
import ModalBase, { IModalBaseProps, ModalBaseRefType } from "@/Components/Base/ModalBase";
import ComponentePermissao from "@/Components/Base/Permissao/ComponentePermissao";
import ContaSelect from "@/Components/Populados/Financeiro/Conta/ContaSelect";
import Permissoes, { PermissoesKeyType } from "@/Constants/Permissoes";
import { EnumContaViagemSituacao, ContaViagemSituacoesDicionarioAcao } from "@/Models/Domain/Viagem/Financeiro/ContaViagem/ContaViagemSituacao";
import { type AlterarSituacaoType, useContaViagemAlterarSituacao } from "@/Services/Domain/Viagem/Financeiro/ContaViagemService";
import { Col, Form, Row } from "antd";
import { useMemo, useRef } from "react";

type AlterarSituacaoFormType = {
    alteracao : AlterarSituacaoType;
}
type ContaEncerramentoParam = Parameters<typeof useContaViagemAlterarSituacao>[0];

export interface IContaViagemAlterarSituacaoProps extends IModalBaseProps {
    codContaViagem : number;
    codSituacao : EnumContaViagemSituacao;
    onSuccess ?: ContaEncerramentoParam["onSuccess"]
}


export interface IContaViagemAlterarSituacao {

}
export default function ContaViagemAlterarSituacao ({
    codContaViagem,
    codSituacao,
    onSuccess,
    ...rest
}:IContaViagemAlterarSituacaoProps) {
    const [ form ] = Form.useForm<AlterarSituacaoFormType>();
    const refModal = useRef<ModalBaseRefType|null>(null);

    const {
        mutate,
        isPending
    } = useContaViagemAlterarSituacao({
        onSuccess : (...rest) => {
            refModal.current?.fechar();
            onSuccess?.(...rest);
        }
    });

    const permissaoNescessaria = useMemo<Array<keyof PermissoesKeyType>>(() => {
        switch (codSituacao)
        {
            case EnumContaViagemSituacao.EmLancamento:
                return ["DomainViagemFinanceiroContaViagemAbrir"];
            case EnumContaViagemSituacao.Lancado:
                return ["DomainViagemFinanceiroContaViagemLancar"];
            case EnumContaViagemSituacao.Encerrado:
                return ["DomainViagemFinanceiroContaViagemEncerrarConta"];
        }

        return [
            "DomainViagemFinanceiroContaViagemAbrir",
            "DomainViagemFinanceiroContaViagemLancar",
            "DomainViagemFinanceiroContaViagemEncerrarConta"
        ];
    }, [codSituacao]);

    if (codSituacao == undefined || codSituacao <= 0) return <></>;

    return <ComponentePermissao permissoes={permissaoNescessaria}>
        <ModalBase
            {...rest}
            ref={refModal}
            title={ContaViagemSituacoesDicionarioAcao[codSituacao]}
            textButtonOpen={ContaViagemSituacoesDicionarioAcao[codSituacao]} 
            propsButtonOpen={{ title : `${ContaViagemSituacoesDicionarioAcao[codSituacao]} ADV`, size : "small", danger : true }}
            onOk={() => {
                form.submit();
            }}
            confirmLoading={isPending}
        >
            <Form 
                size="small"
                form={form}
                component={"div"}
                layout={"vertical"}
                autoComplete={"off"}
                onFinish={(v) => mutate({
                    ...v.alteracao,
                    codContaViagem : codContaViagem,
                    codSituacao : codSituacao
                })}
            >
                <Row gutter={8} wrap>
                    <Col xs={24}>
                        <Form.Item name={["alteracao", "codContaSaldoResidual"]} label="Destinação do saldo residual" rules={[{ required : true }]}>
                            <ContaSelect />
                        </Form.Item>
                    </Col>
                </Row>
            </Form>
        </ModalBase>
    </ComponentePermissao>
}